import Vue from 'vue';

/**
 * 登录 username Cookie：值为 nickName，供后续请求自动携带。
 */
const USERNAME_COOKIE = 'username';
/** 与后端 token_timeout 默认 86400 秒一致 */
const COOKIE_EXPIRE = '1d';

/**
 * 获取 vue-cookies 实例。
 * @param {Object} vueInstance Vue 组件实例，非组件场景可传 null
 */
function getCookies(vueInstance) {
  return (vueInstance && vueInstance.$cookies) || Vue.prototype.$cookies;
}

/**
 * 登录成功后设置 username Cookie，值为 nickName。
 * @param {Object} vueInstance Vue 组件实例（需已挂载 vue-cookies）
 * @param {string} nickName 用户姓名
 */
export function setLoginUsernameCookie(vueInstance, nickName) {
  const cookies = getCookies(vueInstance);
  if (!cookies || !nickName) {
    return;
  }
  cookies.set(USERNAME_COOKIE, nickName, COOKIE_EXPIRE, '/');
}

/**
 * 退出登录或登录超时时清除 username Cookie。
 * @param {Object} vueInstance Vue 组件实例，非组件场景可传 null
 */
export function clearLoginUsernameCookie(vueInstance) {
  const cookies = getCookies(vueInstance);
  if (!cookies) {
    return;
  }
  cookies.remove(USERNAME_COOKIE, '/');
}
